import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { IConfigurationData, IConfigurationService } from '../../services/configuration/configuration-service.interface';

@Component({
  selector: 'gtd-auth-layout',
  templateUrl: './auth.layout.html',
})
export class AuthLayoutPage {
  constructor(
    @Inject('IConfigurationService') public configurationService: IConfigurationService,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    this.activatedRoute.data.subscribe((data: { configurationData: IConfigurationData }) => {
      this.configurationService.setData(data.configurationData);
      this.document.getElementById('app-favicon').setAttribute('href', data.configurationData ? data.configurationData.brand.icon : '');
    });
  }
}
